import { CITY, CITY_NAME } from '../model';

function setLocationPointCity({ location, city }) {
  return (
    location && {
      ...location,
      [CITY]: city,
      [CITY_NAME]: city.addressName || city.name,
    }
  );
}

export default setLocationPointCity;
